export function waitForToken(maxWaitTime = 5000, interval = 100) {
    return new Promise((resolve, reject) => {
      const startTime = Date.now()
  
      const checkToken = () => {
        const token = localStorage.getItem('DEVICE_REG_TOKEN')
        if (token) {
          resolve(token)
        } else if (Date.now() - startTime >= maxWaitTime) {
          reject(new Error('Timed out waiting for access token'))
        } else {
          setTimeout(checkToken, interval)
        }
      }
  
      checkToken()
    })
  }
  